import {kendoFilterOperatorList} from './kendoFilterOperatorList';

export const buildFilterLabel = (filter, fields, appliedFilter, includeStartParen = false) => {
    if (filter === undefined || filter === null) {
        return '';
    }

    let currentLogic = filter.logic;
    if (appliedFilter === undefined) appliedFilter = '';
    let operand = '';
    if (filter && filter.filters && fields.length > 0) {
        filter.filters.forEach((f) => {
            if (f.logic) {
                appliedFilter = appliedFilter + ` ${f.logic}`;
                appliedFilter = `${buildFilterLabel(f, fields, appliedFilter, true)})`;
            }
            else {
                if (f.field) {
                    const startParen = includeStartParen ? '(' : '';
                    let fieldName = fields.find(field => field.name === f.field);
                    let fieldNameLabel = fieldName ? fieldName.label : '';

                    operand = kendoFilterOperatorList.find((o) => o.operator === f.operator);
                    if ( appliedFilter.length > 0 && !( appliedFilter.toLowerCase().endsWith('and') || appliedFilter.toLowerCase().endsWith('or'))) {
                        appliedFilter += ` ${currentLogic}`;
                    }
                    const displayValue = f.value === null || f.value === undefined ? '' : typeof(f.value) === 'boolean' || typeof(f.value) === 'string' ? `'${f.value}'` : f.value;
                    appliedFilter = appliedFilter + ` ${startParen}[${fieldNameLabel ? fieldNameLabel : f.field}] ${operand ? operand.label : f.operator} ${displayValue}`;
                }
            }
        });
    }
    return appliedFilter;
};
